export const CONTAINER_ALLOWED_CHILDREN = [
  'ActivityIndicator',
  'ForgotPasswordForm',
  'OAuthProviderButton',
  'OAuthProviderList',
  'OtpForm',
  'SignInForm',
  'SignUpForm',
  'Accordion',
  'Surface',
  'Avatar',
  'AvatarGroup',
  'Badge',
  'MediaCard',
  'MetricCard',
  'Chip',
  'ChipGroup',
  'DataTable',
  'DatePicker',
  'Dialog',
  'Pagination',
  'Rating',
  'SearchInput',
  'Tabs',
  'Toolbar',
  'Skeleton',
  'SkeletonCard',
  'SkeletonList',
  'SkeletonText',
  'IconButton',
  'Uploader',
  'FlatList',
  'SectionList',
  'BottomSheet',
  'ProductCard',
  'View',
  'ScrollView',
  'Grid',
  'Gradient',
  'Divider',
  'Text',
  'Heading',
  'Icon',
  'Image',
  'Hero',
  'KeyboardAvoidingView',
  'Button',
  'ButtonGroup',
  'RadioGroup',
  'ThemeModeToggle',
  'TextInput',
  'TimePicker',
  'Form',
  'Card',
  'EmptyState',
  'SectionHeader',
  'PostCard',
  'ChatListItem',
  'MessageBubble',
  'ProgressRing',
  'ReaderSurface',
  'ContentRail',
  'MissingElement',
] as const;

export const CONTENT_RAIL_ALLOWED_CHILDREN = [
  'Chip',
  'ChipGroup',
  'MediaCard',
  'MetricCard',
  'Avatar',
  'AvatarGroup',
  'Badge',
  'Button',
  'IconButton',
  'View',
  'ScrollView',
  'Card',
  'Image',
  'ProductCard',
  'PostCard',
  'ChatListItem',
  'MessageBubble',
  'MissingElement',
] as const;

export const SCREEN_SECTION_ALLOWED_CHILDREN = [...CONTAINER_ALLOWED_CHILDREN] as const;

export const SCREEN_ALLOWED_CHILDREN = ['ScreenSection', ...CONTAINER_ALLOWED_CHILDREN] as const;
